/**
* @file 分账号添加
*/
<template>
  <div class="p-account-add">
    <div class="p-account-form">
      <plv-form
        ref="form"
        :model="form"
        :rules="rules"
        form-width="600px"
        label-width="110px"
      >
        <plv-form-item
          label="分账号邮箱"
          prop="email"
          required
        >
          <plv-input
            v-model.trim="form.email"
            placeholder="请输入分账号电子邮箱"
            size="medium"
          />
        </plv-form-item>
        <plv-form-item
          label="分账号密码"
          prop="password"
          required
        >
          <plv-input
            v-model.trim="form.password"
            :en-length="1"
            :maxlength="32"
            placeholder="请输入分账号密码"
            size="medium"
            type="password"
          />
        </plv-form-item>
        <plv-form-item
          label="联系人"
          prop="contacts"
          required
        >
          <plv-input
            v-model.trim="form.contacts"
            :en-length="1"
            :maxlength="50"
            placeholder="请输入联系人姓名"
            size="medium"
          />
        </plv-form-item>
        <plv-form-item
          label="手机号码"
          prop="phone"
          required
        >
          <plv-input
            v-model.trim="form.phone"
            placeholder="请输入联系人手机号码"
            size="medium"
          />
        </plv-form-item>
        <plv-form-item label="账号到期时间" label-height="40px">
          <plv-radio-group v-model="form.expireType">
            <plv-radio value="group">跟随主账号</plv-radio>
            <plv-radio value="custom">
              自定义日期
            </plv-radio>
            <plv-date-picker
              v-model="form.expireDate"
              :disabled="form.expireType !== 'custom'"
              disabled-before-now
              value-format="timestamp"
            />
          </plv-radio-group>
        </plv-form-item>
        <plv-form-item
          label="备注"
          prop="memo"
        >
          <plv-input
            v-model.trim="form.memo"
            :en-length="1"
            :maxlength="50"
            placeholder="请填写分公司名称"
            size="medium"
          />
        </plv-form-item>
        <plv-form-item
          label="频道数"
          prop="maxChannels"
        >
          <template slot="tips">
            <span>{{ $_getChannelTip(form.maxChannels) }}</span>
          </template>
          <plv-input-number
            v-model.trim="form.maxChannels"
            :en-length="1"
            placeholder="请输入可用频道数"
            size="medium"
          />
        </plv-form-item>
        <plv-form-item
          label="计费方式"
          prop="chargeType"
          required
        >
          <plv-select v-model="form.chargeType">
            <plv-select-option
              v-for="option of chargeTypeOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            />
          </plv-select>
        </plv-form-item>
        <plv-form-item
          v-if="form.chargeType === chargeTypeEnum.Minutes"
          label="分钟数"
          prop="minutes"
        >
          <template v-if="isResourceLimit" slot="tips">
            <span>{{ $_getMinutesTip(form.minutes) }}</span>
          </template>
          <plv-input-number
            v-model.trim="form.minutes"
            :en-length="1"
            placeholder="请输入分钟数"
            size="medium"
            :precision="precisionNum"
            :max="assignableResource.minutes"
          />
          <div class="p-account-add__tip">
            <plv-tips>分账号为分钟数计费时，分钟数为0且账号有金额，也可以正常使用</plv-tips>
          </div>
        </plv-form-item>
        <plv-form-item
          v-if="form.chargeType === chargeTypeEnum.totalConcurrent || form.chargeType === chargeTypeEnum.ParallelConcurrent"
          label="并发数"
          prop="maxChannels"
        >
          <template v-if="isResourceLimit" slot="tips">
            <span>{{ $_getConcurrentTip(form.concurrent, 0) }}</span>
          </template>
          <plv-input-number
            v-model.trim="form.concurrent"
            :en-length="1"
            :min="1"
            placeholder="请输入可用并发数"
            size="medium"
            :precision="precisionNum"
            :max="assignableResource.concurrent"
          />
          <div class="p-account-add__tip">
            <plv-tips>并发至少分配 1</plv-tips>
          </div>
        </plv-form-item>

        <plv-form-item
          v-if="isAmountType"
          label="金额"
          prop="balance"
          tips-inline
          tips-text="纯金额模式采取后结算方式，次日结算用量扣除对应金额"
        >
          <plv-input-number
            v-model.trim="form.balance"
            :en-length="1"
            :max="100000000"
          />
        </plv-form-item>

        <plv-form-item
          v-if="isAmountType && isResourceLimit"
        >
          <plv-tips>{{ $_getBalanceTip(form.balance) }}</plv-tips>
        </plv-form-item>

        <plv-form-item
          v-if="vodEndDate"
          :tips-text="isResourceLimit ? $_getSpaceTip(form.space) : ''"
          label="点播空间"
          prop="space"
        >
          <plv-input-number
            v-model="form.space"
            :en-length="1"
            :max="100000000"
            placeholder="请输入空间容量"
          >
            <template slot="suffix">
              <span class="p-vod-setting-form-item__unit">GB</span>
            </template>
          </plv-input-number>
        </plv-form-item>

        <plv-form-item
          v-if="vodEndDate"
          :tips-text="isResourceLimit ? $_getFlowTip(form.flow) : ''"
          label="点播流量"
          prop="flow"
        >
          <plv-input-number
            v-model="form.flow"
            :en-length="1"
            :max="100000000"
            placeholder="请输入流量容量"
          >
            <template slot="suffix">
              <span class="p-vod-setting-form-item__unit">GB</span>
            </template>
          </plv-input-number>
        </plv-form-item>

        <plv-form-item>
          <plv-button @click="handleSubmit">保存并创建分账号</plv-button>
        </plv-form-item>
      </plv-form>
    </div>
  </div>
</template>

<script>
import { chargeTypeEnum, defaultFormRules } from '@/utils/type';
import accountInfoMixin from '@/mixins/accountInfo';
import { mapState } from 'vuex';

export default {
  mixins: [accountInfoMixin],
  data() {
    return {
      form: {
        email: '',
        password: '',
        contacts: '',
        phone: '',
        expireType: 'group',
        expireDate: '',
        memo: '',
        maxChannels: 50,
        chargeType: '',
        minutes: 180,
        concurrent: 0,
        balance: 0,
        flow: 10,
        space: 10,
      },
      dueDateType: 'follow', // 跟随主账号follow/自定义日期custom
      rules: {
        ...defaultFormRules,
        contact: {
          type: 'string',
          message: '请输入联系人姓名',
          required: true,
        },
        chargeType: {
          type: 'string',
          message: '请选择计费方式',
          required: true
        },
        phone: [
          { type: 'string', message: '请输入联系人手机号码', required: true },
          { pattern: /^\d+$/, message: '手机号格式错误' },
        ],
      },
      chargeTypeEnum,
      precisionNum: 0
    };
  },

  computed: {
    ...mapState({
      overViewInfo: state => state.account.overViewInfo
    }),
    assignableResource() {
      const { concurrenceAssignable: concurrent, durationAssignable: minutes } = this.overViewInfo.assignableResourceVO;
      return {
        concurrent: concurrent > 0 ? concurrent : 0,
        minutes: minutes > 0 ? minutes : 0
      };
    },
    chargeTypeOptions() {
      const optionData = [
        { label: '按分钟数计费', value: 'minutes' }
      ];
      // 并行并发或者累计并发，才支持选“并发计费”
      const { totalConcurrent, ParallelConcurrent } = this.chargeTypeEnum;
      if (this.concurrentType === totalConcurrent || this.concurrentType === ParallelConcurrent) {
        optionData.push({ label: '按并发计费', value: this.concurrentType });
      }
      return optionData;
    }
  },

  watch: {
    concurrentType: {
      handler(val) {
        if (val === this.chargeTypeEnum.totalConcurrent || val === this.chargeTypeEnum.ParallelConcurrent) {
          this.form.concurrent = 1;
        }
      },
      immediate: true
    }
  },

  methods: {
    async handleSubmit() {
      if (!this.vodEndDate) {
        this.form.flow = 0;
        this.form.space = 0;
      }
      // 不是分钟数模式需要将分钟数置为0
      if (this.form.chargeType !== chargeTypeEnum.Minutes) {
        this.form.minutes = 0;
      } else {
        this.form.concurrent = 0;
      }
      if (!this.isCreateSubAccountEnable) {
        this.$toast.error('当前账号没有资源，无法创建，请联系商务或者售后');
        return;
      }
      try {
        await this.$refs.form.validate();
        this.$emit('loading');
        const form = { ...this.form };
        const res = await this.$store.dispatch('account/addSubAccount', form);
        const detailRes = await this.$store.dispatch('account/getSubAccountInfo', res);
        this.$toast.success('创建成功');
        this.$store.commit('account/setSubAccountInfo', detailRes);
        // 后端重新设置有延迟
        setTimeout(async () => await this.$store.dispatch('account/getOverViewInfo'), 300);
        this.$router.push(`/group/subAccount/${res}/detail`);
      } catch {
      } finally {
        this.$emit('cancelLoading');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.p-account-form {
  padding: 0 18px 25px 18px;

  .plv-date-picker {
    margin-left: 10px !important;
  }

  .plv-radio-group {
    align-items: center;
  }
}
.p-account-add__tip {
  margin-top: 16px;
}

</style>
